exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#language .nav-link.active{\r\n    background-color: #004d99!important;\r\n    color: #fff!important;\r\n}\r\n\r\n#language .nav-link{\r\n    background-color: #e0e0e0!important;\r\n    color: #000!important;\r\n}\r\n\r\n.listGroupItemGetPdfFina {\r\n    text-align: center !important;\r\n    cursor: pointer;\r\n}", ""]);

